import React from 'react';
import '../styles/Titulo.css';
import logoleo from '../imagenes/logoleo.svg';

const Titulo = () => {
    return (
        <div className='titulo'>
            <img src={logoleo} className='imagentitle'/>
        </div>
    );
}
 
export default Titulo;